export default __webpack_public_path__ + "static/media/mapPinClosed.fcb66adb.svg";